import script from "./BrushMapPreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./BrushMapPreview.vue?vue&type=script&setup=true&lang=ts"

import "./BrushMapPreview.vue?vue&type=style&index=0&id=0fcc5a92&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fcc5a92"]])

export default __exports__